
    import Vue from "vue";
    import Component from "vue-class-component";
    import Store from "@/store/store";
    import authentication from "@/utilities/Authentication";
    import Colours from "@/utilities/Colours";
    import { UserRole } from "@/model/Enums";

    @Component({})
    export default class SignedInLayout extends Vue {

        // mounted(): void {
        //     document.body.style.backgroundColor = "#fff";
        // }

        async mounted(): Promise<void> {
            // check to see if we need to load settings for colours, etc.
            await this.$store.dispatch("loadClientSettings");
        }

        isCollapsed: boolean = false;

        versionNumber = `Version ${process.env.VUE_APP_VERSION}`;

        get signedInUserName(): string {
            return Store.getters.signedInUser?.fullname ?? "(not signed in)";
        }

        get initials(): string {
            const parts = this.signedInUserName.split(" ");
            return parts.reduce((initials, part) => initials + part.substring(0, 1), "");
        }

        get isAdmin(): boolean {
            return Store.state.signedInUser?.role == UserRole.Admin;
        }

        get isUserAdmin(): boolean {
            return this.isAdmin || Store.state.signedInUser?.isUserAdmin == true;
        }

        get isClient(): boolean {
            return Store.state.signedInUser?.role == UserRole.Client;
        }

        get isSite(): boolean {
            const role = Store.state.signedInUser?.role ?? UserRole.None;
            return role == UserRole.Site || role == UserRole.SitePathways || role == UserRole.SiteSponsors;
        }

        get canSeeWorkPermitForms(): boolean {
            const role = Store.state.signedInUser?.role ?? UserRole.None;
            const siteHasWorkPermitForms = Store.state.signedInUser?.siteHasWorkPermitForms ?? false;
            return role === UserRole.Admin || (
                siteHasWorkPermitForms && (
                    role === UserRole.Client ||
                    role === UserRole.Site ||
                    role === UserRole.SitePathways ||
                    role === UserRole.SiteSponsors
                )
            );
        }

        get bannerColour(): string {
            return this.$store.state.clientSettings?.client?.bannerColour ?? "#888";
        }

        get isBannerDark(): boolean {
            return Colours.isDark(this.bannerColour);
        }

        //
        // -- methods
        //

        signOut(): void {
            // Not using async / await here so we'll just trust the sign out occurs in the background
            // and rely on error handler if anything screws up.
            authentication.signOut();

            this.$router.push("/");
        }
    }
